/**
 * @generated SignedSource<<11f2a918d40f08382784aac41d9aec78>>
 * @relayHash dcc67a3c302bf1451aa072fa5b312aec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 43f604e8c261aebb7a014bc621255865be5532c76b95bb916a3188eab46880eb

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type ConfluenceWorkflowReviewStatus = "APPROVED" | "CANCELED" | "DENIED" | "PENDING" | "%future added value";
export type GraphQLContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "%future added value";
export type ConfluenceCreateContentApprovalRequestInput = {
  comment?: string | null | undefined;
  contentId: AGG$Long;
  contentStatus: GraphQLContentStatus;
  reviewers?: ReadonlyArray<ConfluenceContentApprovalReviewerInput | null | undefined> | null | undefined;
  version: number;
};
export type ConfluenceContentApprovalReviewerInput = {
  isRequired?: boolean | null | undefined;
  principalId: string;
  principalType: ConfluencePrincipalType;
};
export type ApprovalsContextCreateWorkflowReviewMutation$variables = {
  cloudId: string;
  createContentApprovalRequestInput: ConfluenceCreateContentApprovalRequestInput;
};
export type ApprovalsContextCreateWorkflowReviewMutation$data = {
  readonly confluence_createContentApproval: {
    readonly contentApproval: {
      readonly comment: string | null | undefined;
      readonly id: string;
      readonly reviewStatus: ConfluenceWorkflowReviewStatus;
      readonly reviewers: ReadonlyArray<{
        readonly isRequired: boolean;
        readonly principalId: string;
        readonly principalType: string;
        readonly user: {
          readonly displayName: string | null | undefined;
          readonly emails: ReadonlyArray<{
            readonly isPrimary: boolean | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined> | null | undefined;
          readonly id: string | null | undefined;
          readonly photos: ReadonlyArray<{
            readonly isPrimary: boolean | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined>;
      readonly workflowApplicationId: string | null | undefined;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
  } | null | undefined;
};
export type ApprovalsContextCreateWorkflowReviewMutation = {
  response: ApprovalsContextCreateWorkflowReviewMutation$data;
  variables: ApprovalsContextCreateWorkflowReviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "createContentApprovalRequestInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "createContentApprovalRequestInput",
    "variableName": "createContentApprovalRequestInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = [
  {
    "kind": "ScalarField",
    "name": "isPrimary"
  },
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v8 = {
  "concreteType": "ConfluenceWorkflowReview",
  "kind": "LinkedField",
  "name": "contentApproval",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "workflowApplicationId"
    },
    {
      "kind": "ScalarField",
      "name": "reviewStatus"
    },
    {
      "kind": "ScalarField",
      "name": "comment"
    },
    {
      "concreteType": "ConfluenceWorkflowReviewer",
      "kind": "LinkedField",
      "name": "reviewers",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "principalType"
        },
        {
          "kind": "ScalarField",
          "name": "principalId"
        },
        {
          "kind": "ScalarField",
          "name": "isRequired"
        },
        {
          "concreteType": "AtlassianUser",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            {
              "kind": "ScalarField",
              "name": "displayName"
            },
            {
              "concreteType": "AtlassianUserPhoto",
              "kind": "LinkedField",
              "name": "photos",
              "plural": true,
              "selections": (v7/*: any*/)
            },
            {
              "concreteType": "AtlassianUserEmail",
              "kind": "LinkedField",
              "name": "emails",
              "plural": true,
              "selections": (v7/*: any*/)
            }
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ApprovalsContextCreateWorkflowReviewMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceContentApprovalPayload",
        "kind": "LinkedField",
        "name": "confluence_createContentApproval",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          },
          (v8/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApprovalsContextCreateWorkflowReviewMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceContentApprovalPayload",
        "kind": "LinkedField",
        "name": "confluence_createContentApproval",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          },
          (v8/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "dcc67a3c302bf1451aa072fa5b312aec",
    "id": "43f604e8c261aebb7a014bc621255865be5532c76b95bb916a3188eab46880eb",
    "metadata": {},
    "name": "ApprovalsContextCreateWorkflowReviewMutation",
    "operationKind": "mutation",
    "text": "mutation ApprovalsContextCreateWorkflowReviewMutation($cloudId:ID!,$createContentApprovalRequestInput:ConfluenceCreateContentApprovalRequestInput!){confluence_createContentApproval(cloudId:$cloudId,createContentApprovalRequestInput:$createContentApprovalRequestInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},contentApproval{id,workflowApplicationId,reviewStatus,comment,reviewers{principalType,principalId,isRequired,user{id,displayName,photos{isPrimary,value},emails{isPrimary,value}}}}}}"
  }
};
})();

(node as any).hash = "7aac889eeb2c9a4140e4c54a84dd5a22";

export default node;
